module.exports = "/_next/static/images/Placeholder-65c08d093ed42e5f96116c82c1dea9f9.jpeg";